module.exports = __webpack_public_path__ + "static/media/sy.84c17ae8.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/sy.svg
// module id = 2218
// module chunks = 0